export default {
  "2": {
    text: "Für welche Facharztrichtung suchen Sie eine/n Arzt/Klinik?",
    type: "textRadio",
    search: "facharztrichtungen",
    info:
      "Ein Facharzt/Spezialist ist ein Arzt mit fundierter Fachkompetenz und Erfahrung in einem bestimmten medizinischen Bereich.",
  },
  "17": {
    text: "Wurden Ihre Beschwerden schon behandelt?",
    type: "buttons",
    options: [{ value: "Ja" }, { value: "Nein" }],
  },
  "20": {
    text: "Tragen Sie derzeit eine Zahnregulierung?",
    type: "buttons",
    options: [{ value: "Ja" }, { value: "Nein" }],
    info:
      "Eine Zahnregulierung kann eine Zahnspange, Zahnschiene, Invisalign oder ähnliches sein, welche Zahn- und Kieferfehlstellungen korrigiert und in die gewünschte Position bringen soll.",
  },
  "21": {
    text: "Haben Sie einen Zahnersatz?",
    type: "checkbox",
    options: [
      { value: "Festsitzender Zahnersatz (z.B. Brücke)" },
      { value: "Abnehmbarer Zahnersatz (Voll-/Teilprothese)" },
      { value: "Nein" },
    ],
    info:
      "Ein Zahnersatz ersetzt Ihre/n ursprüngliche/n, natürliche/n Zahn/Zähne entweder durch einen festsitzenden Zahnersatz (Krone, Brücke, Stiftzahn, Implantat, Veneers) oder einen abnehmbaren Zahnersatz (Vollprothese, Teilprothese).",
  },
};
